import * as tslib_1 from "tslib";
import Vue from "vue";
import { Component } from "vue-property-decorator";
import OidcService from "@/services/authentication/OIDC/OidcService";
let OidcCallbackView = class OidcCallbackView extends Vue {
    constructor() {
        super();
        this.authService = new OidcService();
        this.user = null;
    }
    async mounted() {
        try {
            this.user = await this.authService.getUser();
            await this.authService.signinRedirectCallback();
            this.$router.push("/user/profile");
        }
        catch (error) {
            console.log('Error in oidc callback: ' + error.message);
        }
    }
};
OidcCallbackView = tslib_1.__decorate([
    Component({
        name: "OidcCallback",
        computed: {}
    })
], OidcCallbackView);
export default OidcCallbackView;
